import ArrowDown from '../assets/svg/arrow-down.svg?raw';
import ArrowRight from '../assets/svg/arrow-right.svg?raw';
import Plus from '../assets/svg/plus.svg?raw';
import Success from '../assets/svg/success.svg?raw';
import Cursus from '../assets/svg/cursus.svg?raw';
// import Download from '../assets/svg/download.svg?raw';
import FilePlaceholder from '../assets/svg/file-placeholder.svg?raw';
import DetailsAlert from '../assets/svg/details/alert.svg?raw';
import DetailsCalendar from '../assets/svg/details/calendar.svg?raw';
import DetailsCarry from '../assets/svg/details/carry.svg?raw';
import DetailsEuro from '../assets/svg/details/euro.svg?raw';
import DetailsFree from '../assets/svg/details/free.svg?raw';
import DetailsGauge from '../assets/svg/details/gauge.svg?raw';
import DetailsHandicap from '../assets/svg/details/handicap.svg?raw';
import DetailsInfo from '../assets/svg/details/info.svg?raw';
import DetailsOnSite from '../assets/svg/details/on-site.svg?raw';
import DetailsPlace from '../assets/svg/details/place.svg?raw';
import DetailsTime from '../assets/svg/details/time.svg?raw';
import DetailsVideo from '../assets/svg/details/video.svg?raw';


export default {
    'arrow-down': ArrowDown,
    'arrow-right': ArrowRight,
    'cursus': Cursus,
    'details-alert': DetailsAlert,
    'details-calendar': DetailsCalendar,
    'details-carry': DetailsCarry,
    'details-euro': DetailsEuro,
    'details-free': DetailsFree,
    'details-gauge': DetailsGauge,
    'details-handicap': DetailsHandicap,
    'details-info': DetailsInfo,
    'details-on-site': DetailsOnSite,
    'details-place': DetailsPlace,
    'details-time': DetailsTime,
    'details-video': DetailsVideo,
    'file-placeholder': FilePlaceholder,
    'plus': Plus,
    'success': Success,
}
